import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';
import { fg } from '@townsquare/stat-sig/gate';

import TagUpdatesViewQuery, {
	type TagUpdatesViewQuery as TagUpdatesViewQueryType,
} from '../TagUpdatesView/__generated__/TagUpdatesViewQuery.graphql';

export const tagUpdatesResource: RouteResource<
	PreloadedQuery<TagUpdatesViewQueryType, Record<string, unknown>>
> = createRelayResource<TagUpdatesViewQueryType>({
	getQuery: (routerContext) => {
		return {
			query: TagUpdatesViewQuery,
			variables: {
				tagUUID: routerContext?.match?.params.id,
				shouldFetchUpdatesTabData: !fg('goal_types_m3_bundled_updates'),
			},
			options: {
				fetchPolicy: 'store-and-network',
			},
		};
	},
});
